import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import Card from '../../../../../molecules/Card'
import OpalHeading from '../../../../../opal/OpalHeading'
import OpalPresentationTable from '../../../../../organisms/DenaliAnalysis/tables/presentation'
import { dataCatalog } from '../../../../../../api/coreData'
import Loading from '../../../../../molecules/Loading'
import ModifyDatasourceRestrictionsDialog from '../../dialogs/ModifyDatasourceRestrictionsDialog'
import SydButton from '../../../../../commonDesign/Button'

function getRestrictionValue (type, restrictions = [], datasource) {
  const r = restrictions.find(r => r.type === type)
  if (!r) return 'Not Set'

  if (datasource.type === 'table') {
    const dp = datasource.datapoints?.find(d => d.catalogDatapointId === r.datapointId)
    if (!dp) return `Datapoint Not Found ${r.datapointId}`
    return dp.accessor
  } else if (datasource.type === 'api') {
    const input = datasource.apiInputs?.find(i => i.catalogApiInputId === r.catalogApiInputId)
    if (!input) return `API Input Not Found ${r.catalogApiInputId}`
    return input.inputName
  }

  return 'Unknown'
}

function RestrictionsTab ({ datasource }) {
  const { data, isLoading } = dataCatalog.useListCatalogRestrictionTypes()
  const modifyDatasourceRestrictionsRef = useRef(null)

  const tableData = useMemo(() => {
    return (data?.restrictionTypes || []).map(rt => ({
      useCase: rt.name,
      restrictionAccessor: getRestrictionValue(rt.restrictionType, datasource.restrictions, datasource)
    }))
  }, [datasource, data])

  if (isLoading) return <Loading />

  if (datasource.type === 'table' || datasource.type === 'api') {
    const accessorLabel = datasource.type === 'table' ? 'Datapoint Accessor' : 'API Input'
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Card variant='clear'>
            <OpalHeading level={1} className='font-size-md flex gap-sm'>
              <span>Contextual Data Restrictions</span>
              <SydButton size='sm' variant='outline' icon='edit' onClick={() => modifyDatasourceRestrictionsRef.current.open(datasource)}>Edit</SydButton>
            </OpalHeading>
            <p>Contextual Data Restrictions allow you to designate fields for filtering within common use-cases.</p>
            <p>If no restriction is applied for that contextual use-case, the data will not be able to be used.</p>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <OpalPresentationTable
            columns={[
              { accessorKey: 'useCase', title: 'Use Case', id: 'useCase' },
              { accessorKey: 'restrictionAccessor', title: accessorLabel, id: 'restrictionAccessor' }
            ]}
            data={tableData}
            defaultSort={[]}
          />
        </Grid>
        <ModifyDatasourceRestrictionsDialog ref={modifyDatasourceRestrictionsRef} />
      </Grid>
    )
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Card>
          Not Supported for {datasource.type}
        </Card>
      </Grid>
    </Grid>
  )
}

RestrictionsTab.propTypes = {
  datasource: PropTypes.shape({
    type: PropTypes.string,
    restrictions: PropTypes.array,
    datapoints: PropTypes.array,
    apiInputs: PropTypes.array
  })
}

export default RestrictionsTab
